let options = ''
self.addEventListener('push', function(event) {

  event.waitUntil(
    self.registration.showNotification(data.title, options)
  );
});

self.addEventListener('message', function(event) {
  if (event.data && event.data.command === 'pushEvent') {
    var data = event.data.data;
    url = data.data.url;
    var action = [];
    for (let i = 0; i < data.actions.length; i++) {
      var obj = { action: `Btn${i}` , title: data.actions[i].title};
      action.push(obj);
    }
    data.actions.forEach(item => {
      var obj = { action: item.action , title: item.title};
      action.push(obj);
    })
    options = {
      body: data.body,
      icon: data.icon,
      vibrate: [100, 50, 100],
      // tag: data.tag,
      badge: data.badge,
      timeStamp: data.timeStamp,
      image: data.image,
      dir: data.dir,
      data: {
        url: data.data.url,
        dateOfArrival: Date.now(),
        primaryKey: '2'
      },
      actions: action
    };
    self.registration.showNotification(data.title, options);
  }
});

self.addEventListener('notificationclick', function(event) {
  event.notification.close();
  if (event.action === 'Btn0') {
    event.waitUntil(
      clients.openWindow(event.notification.actions[0].actions)
    );
  }
  else if (event.action === 'Btn1') {
    event.waitUntil(
      clients.openWindow(event.notification.actions[1].actions)
    );
  }
  else {
    event.waitUntil(
      clients.openWindow(event.notification.data.url)
    );
  }
});

self.addEventListener('install', function(event) {
  self.skipWaiting();
});

self.addEventListener('activate', function(event) {
  event.waitUntil(
    self.clients.claim()
  );
});